<script lang="ts">import { stateUi } from "@infinitro/config";
let { text = "", position = "top", style = {}, action = "hover", show = undefined, children } = $props();
const useAlternative = $derived($stateUi.tooltip.tooltipStyle === "alternative");
const bgColor = $derived(useAlternative ? "var(--color-background-900)" : "var(--color-neutral-900)");
let visible = $state(false);
let triggerEl = $state();
let tooltipPos = $state.raw({
	left: 0,
	top: 0
});
function computeCoords() {
	if (!triggerEl) return;
	const rect = triggerEl.getBoundingClientRect();
	const offset = 8;
	const bottomOffset = 14;
	switch (position) {
		case "bottom":
			tooltipPos = {
				left: rect.left + rect.width / 2,
				top: rect.bottom + bottomOffset
			};
			break;
		case "top":
			tooltipPos = {
				left: rect.left + rect.width / 2,
				top: rect.top - offset
			};
			break;
		case "left":
			tooltipPos = {
				left: rect.left - offset,
				top: rect.top + rect.height / 2
			};
			break;
		case "right":
			tooltipPos = {
				left: rect.right + offset,
				top: rect.top + rect.height / 2
			};
			break;
	}
}
function onShow() {
	if (!text) return;
	computeCoords();
	visible = true;
}
function onHide() {
	visible = false;
}
function onClick() {
	if (visible) onHide();
	else onShow();
}
$effect(() => {
	if (show === true) onShow();
	else if (show === false) onHide();
});
let transformMap = $derived({
	bottom: "translateX(-50%)",
	top: "translateX(-50%) translateY(-100%)",
	left: "translateX(-100%) translateY(-50%)",
	right: "translateY(-50%)"
});
let tooltipStyle = $derived([
	`position:fixed`,
	`left:${tooltipPos.left}px`,
	`top:${tooltipPos.top}px`,
	`transform:${transformMap[position]}`,
	`background-color:${bgColor}`,
	`font-size:10px`,
	`border-radius:12px`,
	`padding:8px 16px`,
	`color:#fff`,
	`z-index:9999`,
	`white-space:nowrap`,
	`pointer-events:none`,
	...Object.entries(style).map(([k, v]) => `${k}:${v}`)
].join(";"));
</script>

<span
	bind:this={triggerEl}
	class="tooltip-trigger"
	role="button"
	tabindex={action === 'click' ? 0 : -1}
	onmouseenter={action === 'hover' ? onShow : undefined}
	onmouseleave={action === 'hover' ? onHide : undefined}
	onclick={action === 'click' ? onClick : undefined}
	onkeydown={action === 'click' ? (e) => e.key === 'Enter' && onClick() : undefined}
>
	{@render children?.()}
</span>

{#if visible && text}
	<div class="tooltip-popup" style={tooltipStyle}>
		{text}
	</div>
{/if}

<style>
	.tooltip-trigger {
		display: inline-block;
	}

	.tooltip-popup {
		animation: tooltip-in 0.2s ease-out;
	}

	@keyframes tooltip-in {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>
